module.exports = __webpack_public_path__ + "img/lb_03.a780fb29.jpg";